import { dialerServiceClient } from "@/api/dialerServiceClient";
import {
  GetDialListReq,
  GetDialListParamReq,
  MediaReq,
  MediaV2Req,
} from "@/pbjs/xcommon/dialer_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";

// lee 绩效接口参数
interface Options {
  pageIndex: number;
  pageSize: number;
  Dialid?: number; // 拨打ID
  Orderid?: string; // 订单ID
  Assignuser?: string; // 分配员工姓名
  ItemId?: number; // 工单分类
  Extnumber?: string; // 分机号
  Disnumber?: string; // 主叫号码
  Destnumber?: string; // 被叫号码
  Supplier?: number; // 供应商名称
  startTimerange: string; // 拨打时间戳
  Createtimerange?: string; // 记录创建时间
  Roleids?: string; // 角色ID
  Sid?: string;
  IsDial?: string; //是否拨通
  QualityEnspection?: string; 
  Aistatus?: string; 
  Aiscorerange?: string;
  Humanscorerange?: string; 
  talkTime?:string//通话时长
}
interface IMediaOptions {
  VOIPRecordID: number;
}
export function getDialList(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetDialListReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDialid(arg.Dialid);
      request.setOrderid(arg.Orderid); // 工单分类
      request.setAssignuser(arg.Assignuser); // 工单分类
      request.setItemid(arg.ItemId); // 工单分类
      request.setExtnumber(arg.Extnumber); // 工单分类
      request.setDisnumber(arg.Disnumber); // 工单分类
      request.setDestnumber(arg.Destnumber); // 工单分类
      request.setSupplier(arg.Supplier); // 工单分类
      request.setStarttimerange(arg.startTimerange); // 工单分类
      request.setCreatetimerange(arg.Createtimerange); // 工单分类
      request.setRoleids(arg.Roleids); // 工单分类
      request.setSid(arg.Sid);
      request.setIsdial(arg.IsDial);
      request.setCalldurationrange(arg.talkTime);//通话时长
      
      let res = await dialerServiceClient.getDialList(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function getDialListParam() {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetDialListParamReq();
      request.setCommonin(setCommon());
      let res = await dialerServiceClient.getDialListParam(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function getDialListMedia(arg: IMediaOptions) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new MediaReq();
      request.setCommonin(setCommon());
      request.setVoiprecordid(arg.VOIPRecordID);
      let res = await dialerServiceClient.media(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function exportDialRecords(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetDialListReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDialid(arg.Dialid);
      request.setOrderid(arg.Orderid); // 工单分类
      request.setAssignuser(arg.Assignuser); // 工单分类
      request.setItemid(arg.ItemId); // 工单分类
      request.setExtnumber(arg.Extnumber); // 工单分类
      request.setDisnumber(arg.Disnumber); // 工单分类
      request.setDestnumber(arg.Destnumber); // 工单分类
      request.setSupplier(arg.Supplier); // 工单分类
      request.setStarttimerange(arg.startTimerange); // 工单分类
      request.setCreatetimerange(arg.Createtimerange); // 工单分类
      request.setRoleids(arg.Roleids); // 工单分类
      request.setSid(arg.Sid);
      request.setIsdial(arg.IsDial);
      request.setCalldurationrange(arg.talkTime);//通话时长

      const res = await dialerServiceClient.exportDialRecords(
        request,
        setMetaData()
      );
      res.on("data", function(response: any) {
        // 字节流不存在并状态为1时,表示传输完成, 返回数据
        resolve(response);
      });
      res.on("err", function(err: any) {
        reject(err);
      });
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}

export function getDialListMediaV2(arg: IMediaOptions) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new MediaV2Req();
      request.setCommonin(setCommon());
      request.setVoiprecordid(arg.VOIPRecordID);

      var stream = dialerServiceClient.mediaV2(request, {});
      stream.on("data", function(response: any) {
        const res: any = response.toObject();

        resolve(res);
      });
      stream.on("err", function(err: any) {
        reject(err);
      });
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
